import get from "lodash/get";

export const AiSearch = (item) => ({
  id: get(item, "id") || "",
  text: get(item, "text") || "",
  score: get(item, "score") || "",
});

export const Meta = (item) => ({
  total: get(item, "total") || 0,
  page: get(item, "page") || 1,
  perPage: get(item, "per_page") || 5,
});

export const AiSearchPairs = (item) => ({
  id: get(item, "id") || "",
  name: get(item, "name") || "",
  organization: get(item, "organization") || "",
});
